import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { GET_DOMAINS_FOR_FILTERS } from 'redux/sagas/actions/dashboard';
import { MODAL_CLOSE } from 'redux/slices/modals';

import Account from 'ui/assets/img/account.svg';
import Creator from 'ui/assets/img/creator.svg';
import Role from 'ui/assets/img/role.svg';
import { AccountCard, Button, DropDown, Icon } from 'ui/atoms';
import { Container } from 'ui/gridSystem';

import MainFont from 'ui/typography/mainFont';

import Modal, { stopEvent } from '../Modal';

import {
  ButtonsContainer,
  ButtonWrapper,
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';
import {
  Content,
  DataDropDownSiteChangeCorporate,
  DropdownContainer,
  IconGoBack,
  TextBack
} from './style';

const modalId = 'AccountDetailsModal';

const steps = {
  DEFAULT: 'details',
  MANAGING_SITES: 'managing sites'
};

const AccountDetailsModal = ({
  onClose,
  account,
  isOpen,
  charging_meta,
  getChargingMetaCorporate,
  changeUserSites
}) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(steps.DEFAULT);

  const [sitesForDropdown, setSitesForDropdown] = useState([]);

  const [selectedSites, setSelectedSites] = useState([]);

  useEffect(() => {
    if (getChargingMetaCorporate) {
      getChargingMetaCorporate();
    }
  }, [getChargingMetaCorporate]);

  useEffect(() => {
    if (charging_meta && charging_meta.Sites) {
      setSitesForDropdown(
        charging_meta.Sites.map(s => ({ value: s, label: s }))
      );
    }
  }, [charging_meta]);
  useEffect(() => {
    if (!isOpen && currentStep !== steps.DEFAULT) {
      setCurrentStep(steps.DEFAULT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleChangeSites = () => {
    setCurrentStep(steps.MANAGING_SITES);
  };

  const confirmChangeSites = () => {
    changeUserSites(account?.id, selectedSites);
  };

  const renderAccountDetails = () => (
    <Content>
      <AccountCard
        img={Account}
        firstTitle="Account"
        secondTitle={t('corporate')}
        firstContent={account?.email}
        corporate
        secondContent={account?.corporation || '-'}
      />
      <AccountCard
        img={Role}
        firstTitle={t('role')}
        corporate
        firstContent={account?.role}
        secondTitle={t('sites')}
        handleChangeSites={handleChangeSites}
        secondContent={account?.sites || ['Site 1', 'Site 2']}
        changeSitesButton
      />
      <AccountCard
        img={Creator}
        firstTitle={t('creator')}
        secondContent={account?.createdOn}
        firstContent={account?.creator || '-'}
        secondTitle={t('createdOn')}
        corporate
      />
    </Content>
  );

  const renderChangeSites = () => (
    <>
      <DropdownContainer>
        <DataDropDownSiteChangeCorporate>
          <DropDown
            placeholder={t('sites')}
            fontWeight="400"
            fontSize="14px"
            menuWidth="280"
            detachedOptions
            isClearable
            options={sitesForDropdown}
            onChange={val => {
              setSelectedSites([...selectedSites, val]);
            }}
            isMulti
            checkBoxMenu
          />
        </DataDropDownSiteChangeCorporate>
      </DropdownContainer>
      <ButtonsContainer>
        <ButtonWrapper>
          <Button
            variant="accept-button"
            onClick={() => {
              if (currentStep === steps.MANAGING_SITES) {
                confirmChangeSites();
              }
            }}
          >
            {t('confirm')}
          </Button>
        </ButtonWrapper>
      </ButtonsContainer>
    </>
  );

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer
            onMouseDown={stopEvent}
            onClick={stopEvent}
            width="auto"
            type="accountDetailsModalCorporate"
          >
            <ModalTitle>
              {currentStep === steps.MANAGING_SITES && (
                <IconGoBack onClick={() => setCurrentStep(steps.DEFAULT)}>
                  <Icon type="icon-back" size={20} />
                  <TextBack>
                    <MainFont type="accountPopupText">{t('back')}</MainFont>
                  </TextBack>
                </IconGoBack>
              )}
              <MainFont type="4" configuration={{ fontSize: 24 }}>
                {currentStep === steps.DEFAULT
                  ? t('account_details')
                  : t('change_site')}
              </MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            {currentStep === steps.DEFAULT
              ? renderAccountDetails()
              : renderChangeSites()}
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

AccountDetailsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  account: PropTypes.object,
  isOpen: PropTypes.bool,
  charging_meta: PropTypes.object,
  getChargingMetaCorporate: PropTypes.func,
  changeUserSites: PropTypes.func
};

AccountDetailsModal.id = modalId;

export default connect(
  state => ({
    account: state?.modals?.payload,
    isOpen: state?.modals?.open,
    charging_meta: state?.dashboard?.charging_meta
  }),
  dispatch => ({
    onClose: () => dispatch(MODAL_CLOSE()),
    getChargingMetaCorporate: () =>
      dispatch({ type: GET_DOMAINS_FOR_FILTERS._REQUEST })
  })
)(AccountDetailsModal);
